import React, { useState, useEffect } from 'react';
import { 
  LayoutDashboard, User, Wallet, Landmark, TrendingUp, Percent, 
  FileText, CreditCard, Folder, Bell, LifeBuoy, Settings, LogOut,
  ChevronRight, ChevronDown, Menu, X,
  // Submenu specific icons (Example set)
  PieChart, Landmark as LoanIcon, Layers, FileClock, FileLineChart, FormInput,
  CheckCircle2
} from 'lucide-react';
import { LuFileText } from "react-icons/lu";
import { LuHistory } from "react-icons/lu";
import { LuRefreshCwOff } from "react-icons/lu";
import { LuPiggyBank } from "react-icons/lu";
import { LuHandCoins } from "react-icons/lu";




import styles from './SideBar2.module.css';
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import { BASE_URL } from '../Api/Api';
import Swal from 'sweetalert2';
import { BRANDING } from '../Branding/Branding';
import { TbMoneybagMinus, TbMoneybagMove, TbMoneybagPlus } from 'react-icons/tb';

export default function Sidebar2({ active = 'dashboard' }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState({});
  const [activePath, setActivePath] = useState('/loans/ledger');
const [showGuarantorMenu, setShowGuarantorMenu] = useState(false);
const [guarantorCount, setGuarantorCount] = useState(0);
  const toggleMenu = () => setIsOpen(!isOpen);
  const toggleDropdown = (menuName) => {
    setExpandedMenus(prev => ({ ...prev, [menuName]: !prev[menuName] }));
  };
const fetchGuarantorRequests = async () => {
  try {
    const token = localStorage.getItem("token");
    const compid = localStorage.getItem("companyId");
    const memberid = localStorage.getItem("memberId");
    const response = await axios.get(
      `${BASE_URL}/member-auth/get_guarantor_requests?company_id=${compid}&member_id=${memberid}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    const requests = response.data?.data || [];

    setGuarantorCount(requests.length);
    setShowGuarantorMenu(requests.length > 0);
  } catch (err) {
    console.error(err);
    setGuarantorCount(0);
    setShowGuarantorMenu(false);
  }
};

useEffect(() => {
  fetchGuarantorRequests();
}, []);

useEffect(() => {
  const refreshSidebar = () => {
    fetchGuarantorRequests();
  };

  window.addEventListener("refreshGuarantorMenu", refreshSidebar);

  return () => {
    window.removeEventListener("refreshGuarantorMenu", refreshSidebar);
  };
}, []);



  useEffect(() => {
    setExpandedMenus((prev) => ({
      ...prev,
      Loans: location.pathname.startsWith('/loans/'),
    }));
  }, [location.pathname]);

    const handleLogout = () => {
  Swal.fire({
    title: "Logout",
    text: "Are you sure you want to logout of this system?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Logout",
    cancelButtonText: "No, Stay Logged In",
    confirmButtonColor: "#dc2626",
    cancelButtonColor: "#64748b",
    reverseButtons: true,
  }).then((result) => {
    if (result.isConfirmed) {
      // Clear stored authentication data
      localStorage.clear();
      sessionStorage.clear();

      navigate("/login", { replace: true });
    }
  });
};

  // Central Menu Configuration supporting custom sub-icons
  const menuItems = [
    { name: 'Dashboard', icon: LayoutDashboard, to: '/dashboard' },
    { name: 'My Profile', icon: User, to: '/profile' },
    { 
      name: 'Savings', 
      icon: Wallet, 
      submenu: [
        { name: 'Savings Overview', to: '/savings/overview', icon: PieChart, activeIcon: PieChart },
        // { name: 'Member Savings', to: '/savings/member-savings', icon: LuPiggyBank, activeIcon: LuPiggyBank },
        { name: 'Savings Ledger', to: '/savings/ledger', icon: LuFileText, activeIcon: LuFileText },
        { name: 'My Savings', to: '/savings/my-savings', icon: TbMoneybagPlus, activeIcon: TbMoneybagPlus },
        { name: 'Withdrawal Request', to: '/savings/withdrawal-request', icon: LuHandCoins, activeIcon: LuHandCoins },
        // { name: 'Deposit History', to: '/savings/deposit-history', icon: LuHistory, activeIcon: LuHistory },
        // { name: 'Standing Orders', to: '/savings/standing-orders', icon: LuRefreshCwOff, activeIcon: LuRefreshCwOff },
      ] 
    },
    {
      name: 'Loans',
      icon: Landmark,
      submenu: [
        { name: 'Loan Overview', to: '/loans/overview', icon: PieChart, activeIcon: PieChart },
        // { name: 'My Loans', to: '/loans/my-loans', icon: LoanIcon, activeIcon: LoanIcon },
        { name: 'Loan Ledger', to: '/loans/ledger', icon: Layers, activeIcon: Layers },
        { name: 'My Loan Applications', to: '/loans/my-loan-applications', icon: TbMoneybagMove, activeIcon: TbMoneybagMove },
        // { name: 'Repayment Schedule', to: '/loans/repayment-schedule', icon: FileClock, activeIcon: FileClock },
        // { name: 'Loan Statement', to: '/loans/statement', icon: FileLineChart, activeIcon: FileLineChart },
        { name: 'New Loan Application', to: '/loans/loan-application', icon: FormInput, activeIcon: FormInput },
...(showGuarantorMenu
  ? [
      {
        name: "Guarantor's Approval",
        to: "/loans/guarantor-approval",
        icon: CheckCircle2,
        activeIcon: CheckCircle2,
        badge: guarantorCount,
      },
    ]
  : []),
      ]
    },
    // { name: 'Shares & Investments', icon: TrendingUp },
    // { name: 'Dividends', icon: Percent, to: '/dividends' },
    // { name: 'Statements', icon: FileText },
    // { name: 'Payments', icon: CreditCard },
    // { name: 'Documents', icon: Folder, to: '/documents' },
    // { name: 'Notifications', icon: Bell, to: '/notifications', badge: 3 },
    { name: 'My Deductions', icon: TbMoneybagMinus, to: '/deductions' },
    { name: 'Support', icon: LifeBuoy, to: '/support' },
    // { name: 'Settings', icon: Settings, to: '/settings' },
    { name: 'Logout', icon: LogOut, isLogout: true },
  ];



  return (
    <>
      {/* MOBILE TOP NAVIGATION BAR */}
      <div className={styles.mobileTopBar}>
         <img
              src={BRANDING?.coopPrimary?.logo}
              alt="logo"
              style={{
                marginRight: 10,
                width: 150,
                height:
                  BRANDING?.coopPrimary?.logo === BRANDING?.coopPrimary?.logo
                    ? 50
                    : 100,
                objectFit: "contain",
              }}
            />
        {/* <div className={styles.mobileLogo}>
          <div className={styles.logoIcon}>R</div>
          <div className={styles.logoText}><h1>RCCG</h1><p>COOPERATIVE</p></div>
        </div> */}
        <button className={styles.hamburgerBtn} onClick={toggleMenu}>
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* OVERLAY BACKDROP */}
      <div className={`${styles.overlay} ${isOpen ? styles.overlayShow : ''}`} onClick={toggleMenu} />

      {/* SIDEBAR CONTAINER */}
      <aside className={`${styles.sidebar} ${isOpen ? styles.sidebarOpen : ''}`}>
        <div className={styles.scrollableMenuSpace}>
          <div className={styles.menuContentWrapper}>
             <img
              src={BRANDING?.coopPrimary?.logo}
              alt="logo"
              style={{
                marginRight: 10,
                width: 150,
                height:
                  BRANDING?.coopPrimary?.logo === BRANDING?.coopPrimary?.logo
                    ? 50
                    : 100,
                objectFit: "contain",
              }}
            />
            {/* <div className={styles.logoArea}>
              <div className={styles.logoIcon}>R</div>
              <div className={styles.logoText}><h1>RCCG</h1><p>COOPERATIVE</p></div>
            </div> */}

            <nav className={styles.navLinks}>
              {menuItems.map((item, index) => {
                const MainIcon = item.icon;
                const hasSubmenu = !!item.submenu;
                const isDropdownOpen = expandedMenus[item.name];
                const isParentActive = hasSubmenu
                    ? item.submenu.some(sub => sub.to === location.pathname)
                    : location.pathname === item.to;
                // const isParentActive = hasSubmenu 
                //   ? item.submenu.some(sub => sub.to === activePath)
                //   : activePath === item.to;

                if (hasSubmenu) {
                  return (
                    <div key={index} className={styles.dropdownGroup}>
                      <button 
                        onClick={() => toggleDropdown(item.name)}
                        className={`${styles.navItem} ${isParentActive ? styles.parentActive : ''}`}
                      >
                        <div className={styles.navLeft}>
                          <MainIcon size={18} /> 
                          <span>{item.name}</span>
                        </div>
                        {isDropdownOpen ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                      </button>

                      {isDropdownOpen && (
                        <div className={styles.submenuContainer}>
                          {item.submenu.map((subItem, subIndex) => {
                            // const isSubActive = activePath === subItem.to;
                            const isSubActive = location.pathname === subItem.to;
                            // Dynamically pick the active icon variant or the regular icon variant
                            const SubIconComponent = isSubActive && subItem.activeIcon 
                              ? subItem.activeIcon 
                              : (subItem.icon || Layers); 

                            return (
                              <button
                                key={subIndex}
                                // onClick={() => setActivePath(subItem.to)}
                                onClick={() => {
                                    setActivePath(subItem.to);
                                    navigate(subItem.to);
                                }}
                                className={`${styles.submenuItem} ${isSubActive ? styles.submenuItemActive : ''}`}
                              >
                                <div className={styles.submenuLeft}>
  <SubIconComponent
    size={16}
    className={styles.submenuIcon}
  />
  <span>{subItem.name}</span>
</div>

{subItem.badge > 0 && (
  <span className={styles.submenuBadge}>
    {subItem.badge}
  </span>
)}
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                }

                return (
                  <button
                    key={index}
                    // onClick={() => setActivePath(item.to)}
                    onClick={() => {
  if (item.isLogout) {
    handleLogout();
  } else {
    setActivePath(item.to);
    navigate(item.to);
  }
}}
                    className={`${styles.navItem} ${isParentActive ? styles.navItemActive : ''} ${item.isLogout ? styles.logoutItem : ''}`}
                  >
                    <div className={styles.navLeft}>
                      <MainIcon size={18} /> 
                      <span>{item.name}</span>
                    </div>
                    {item.badge && <span className={styles.badge}>{item.badge}</span>}
                  </button>
                );
              })}
            </nav>

            <div className={styles.supportSectionFlow}>
              <div className={styles.helpCard}>
                <div className={styles.helpIcon}><LifeBuoy size={24} /></div>
                <h4>Need Help?</h4>
                <p>Our support team is available to assist you.</p>
                <button onClick={() => navigate('/support')} className={styles.supportBtn}>Contact Support</button>
              </div>
            </div>

          </div>
        </div>
      </aside>
    </>
  );
}